import React from 'react';
import { connect } from 'react-redux';
import { withTranslation as translate } from 'react-i18next';

import {
  setAcceptCookieUsage
} from '../actions';

import BlockArea from './BlockArea';

import './UserBlockMessages.scss';


const UserBlockMessageWrapper = ({children}) => (
  <div className="UserBlockMessage">
    {children}
  </div>
)

const AcceptCookieUsageBlockMessage = connect(null, {
  setAcceptCookieUsage
})(translate('userSettings')(({setAcceptCookieUsage, t}) => (
  <UserBlockMessageWrapper>
    <form onSubmit={(e) => {
      e.preventDefault();
      setAcceptCookieUsage(true);
      return false;
    }}>
      <BlockArea areaSlug="message-content" conditions={["message:accept-cookie-usage"]} defaultContent={
        <div>
          <p className="d-inline-block m-0 mr-2">
            {t('messages.acceptCookieUsage.defaultMessage')}
          </p> <button className="btn btn-sm btn-secondary">
            {t('messages.acceptCookieUsage.defaultButtonText')}
          </button>
        </div>
      }/>
    </form>
  </UserBlockMessageWrapper>
)));


const UserBlockMessages = connect(state => ({
  hasAcceptedCookieUsage: state.userSettings.hasAcceptedCookieUsage
}))(({hasAcceptedCookieUsage}) => {
  return (
    <div id="UserBlockMessages">
      {
        false && !hasAcceptedCookieUsage &&
        <AcceptCookieUsageBlockMessage key="accept-cookie-usage" />
      }
    </div>
  );
});

export default UserBlockMessages;